<template>
  <ion-list>
    <ion-list-header>
      <ion-label>Rollen</ion-label>
    </ion-list-header>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToAdmins"
    >
      <ion-icon
        slot="start"
        name="glasses"
      />
      <ion-label>
        Admins
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToModerators"
    >
      <ion-icon
        slot="start"
        name="people"
      />
      <ion-label>
        Moderators
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToPromoters"
    >
      <ion-icon
        slot="start"
        name="megaphone"
      />
      <ion-label>
        Promoter
      </ion-label>
    </ion-item>
    <ion-item
      v-if="role === 'admin'"
      button
      @click="goToCrew"
    >
      <ion-icon
        slot="start"
        name="scan"
      />
      <ion-label>
        Crew
      </ion-label>
    </ion-item>
    <ion-item
      button
      @click="goToUsers"
    >
      <ion-icon
        slot="start"
        name="person"
      />
      <ion-label>Users</ion-label>
    </ion-item>
  </ion-list>
</template>
<script>
import { mapState } from 'vuex';


export default {
  name: 'MenuRoles',
  computed: {
    ...mapState('auth', ['role']),
  },
  methods: {
    goToAdmins() {
      this.$router.push('/admins').catch(() => {});
    },
    goToModerators() {
      this.$router.push('/moderators').catch(() => {});
    },
    goToPromoters() {
      this.$router.push('/promoters').catch(() => {});
    },
    goToCrew() {
      this.$router.push('/crew').catch(() => {});
    },
    goToUsers() {
      this.$router.push('/Users').catch(() => {});
    },
  },
};
</script>
<style>
ion-list {
  background-color: #a9d162;
}
</style>
